import { useCustomQuery } from '../../graphql';

export const useFeatureAssignments = (featureId: string) => {
  const { data, isPending } = useCustomQuery({
    query: FIND_FEATURE_ASSIGNMENTS,
    cacheKey: ['feature', 'assignments', featureId],
    variables: { featureId },
  });

  return { data, isPending };
};

export const FIND_FEATURE_ASSIGNMENTS = `
  query FindFeatureAssignments($featureId: String!) {
    feature {
      findFeatureAssignments(featureId: $featureId) {
        workspaces
        accounts
      }
    }
  }
`;
